import { render, staticRenderFns } from "./RewardsModal.vue?vue&type=template&id=23d8fc1f&scoped=true"
import script from "./RewardsModal.vue?vue&type=script&lang=js"
export * from "./RewardsModal.vue?vue&type=script&lang=js"
import style0 from "./RewardsModal.vue?vue&type=style&index=0&id=23d8fc1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8fc1f",
  null
  
)

export default component.exports